module.exports = __webpack_public_path__ + "static/media/KMH_5251.ca30bfb1.jpg";